import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Loading from '@/shared/components/Loading';
import { paths } from '@/shared/helpers/paths';
import { ApplicantPage } from './components/ApplicantPage';
import './index.scss';

export const cadsAiApplicantsBaseUrl = paths.CADS_AI.DATA_STAR.APPLICANTS;

const Applicants = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path={cadsAiApplicantsBaseUrl} component={ApplicantPage} />
      </Switch>
    </Suspense>
  );
};

export default Applicants;
